import React, {ButtonHTMLAttributes, DetailedHTMLProps, ReactNode, useEffect, useState} from 'react';
import styles from './Tag.module.scss'
import cn from "classnames";
import {useAppDispatch} from "../../store/store";
import {productsActions} from "../../store/productSlice";

interface TagProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    tag: string
    active: boolean
}


const Tag = ({className, active, tag, ...props}: TagProps) => {

    return (
        <button onClick={() => {}} className={cn(styles.tag, className, {
            [styles.active]: active
        })} {...props}>
            {tag}
        </button>
    );
};

export default Tag;
